var _toConsumableArray = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/klatibook/git/adex-platform/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * NOTE: We use _meta as constructor argument in order to make new instances of the object from plain objects
 * and use validations with setters but keep plain object in redux store
 */
var Base = /*#__PURE__*/function () {
  "use strict";

  function Base() {
    _classCallCheck(this, Base);
  }

  _createClass(Base, [{
    key: "plainObj",
    value: function plainObj() {
      var plain = Object.assign({}, this);
      return plain;
    }
  }, {
    key: "plainDeepCopy",
    value: function plainDeepCopy() {
      var plain = this.plainObj();
      var deepCopy = JSON.parse(JSON.stringify(plain));
      return deepCopy;
    }
  }, {
    key: "deepCopyObj",
    value: function deepCopyObj(obj) {
      var deepCopy = JSON.parse(JSON.stringify(obj));
      return deepCopy;
    }
  }], [{
    key: "getIpfsMetaUrl",
    value: function getIpfsMetaUrl(ipfs, ipfsGate) {
      var url = ipfsGate + ipfs;
      return url;
    } // NOTE: update without mutating the item (required by redux)

  }, {
    key: "updateObject",
    value: function updateObject() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$item = _ref.item,
          item = _ref$item === void 0 ? {} : _ref$item,
          _ref$newValues = _ref.newValues,
          newValues = _ref$newValues === void 0 ? {} : _ref$newValues,
          _ref$objModel = _ref.objModel,
          objModel = _ref$objModel === void 0 ? null : _ref$objModel;

      if (!objModel) throw 'objModel is required!';
      var newData = Object.assign({}, newValues);
      var newItem = new objModel(item);

      for (var key in newData) {
        if (newData.hasOwnProperty(key) && key in newItem) {
          var value = newData[key];

          if (value instanceof Date) {
            value = value.getTime();
          }

          if (Array.isArray(value)) {
            value = _toConsumableArray(value);
          } else if (!!value && typeof value === 'object') {
            value = Object.assign({}, value);
          }

          newItem[key] = value;
        }
      }

      var plainObj = newItem.plainDeepCopy();
      return plainObj;
    }
  }]);

  return Base;
}();

module.exports = Base;